import React, { useEffect, useRef } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail, MdOutlinePhone } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

const Contact = () => {
  const whatsappRef = useRef(null);

  useEffect(() => {
    const iti = intlTelInput(whatsappRef.current, {
      initialCountry: "in",
      separateDialCode: true,
      autoPlaceholder: false,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
    });

    // Cleanup function to destroy the instance when the component unmounts
    return () => {
      iti.destroy();
    };
  }, []);

  return (
    <div>
      {/* ======================= breadcrumb start ============================ */}
      <div className="breadcrumb_sec">
        <div className="container">
          <div className="support pb-3">
            <h3>Contact Us</h3>
            <p>Reach out to us. We are here to help you!</p>
          </div>
        </div>
      </div>
      {/* ======================= breadcrumb end ============================ */}

      {/* ======================= Contact Us start ============================ */}
      <div className="support_call_section pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-xl-4">
              <div className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                <div className="item-1">
                  <div className="d-flex align-items-center">
                    <div className="me-2 icon">
                      <a href="#" className="stretched-link">
                        <FaWhatsapp />
                      </a>
                    </div>
                    <div>
                      <h5>Connect on Whatsapp</h5>
                      <p>on 8547563254</p>
                    </div>
                  </div>
                </div>
                <div className="item-2">
                  <div className="arrow-right">
                    <FaArrowRightLong />
                  </div>
                </div>
              </div>
              <div className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                <div className="item-1">
                  <div className="d-flex align-items-center">
                    <div className="me-2 icon">
                      <a href="#" className="stretched-link">
                        <MdOutlineEmail />
                      </a>
                    </div>
                    <div>
                      <h5>Send us an Email</h5>
                      <p>at contact@gmail.com</p>
                    </div>
                  </div>
                </div>
                <div className="item-2">
                  <div className="arrow-right">
                    <FaArrowRightLong />
                  </div>
                </div>
              </div>
              <div className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                <div className="item-1">
                  <div className="d-flex align-items-center">
                    <div className="me-2 icon">
                      <a href="#" className="stretched-link">
                        <MdOutlinePhone />
                      </a>
                    </div>
                    <div>
                      <h5>Get on call with us</h5>
                      <p>on 8547563254</p>
                    </div>
                  </div>
                </div>
                <div className="item-2">
                  <div className="arrow-right">
                    <FaArrowRightLong />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-xl-8">
              <div className="form-box">
                <form action="#" method="post">
                  <div className="row">
                    <div className="send-mgs pb-3">
                      <p>Send us an Email</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label">First Name*</label>
                      <input type="text" className="form-control" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">Email Id*</label>
                      <input type="email" className="form-control" id="email" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="whatsapp" className="form-label">Whatsapp Number*</label>
                      <div className="input-group">
                        <input
                          type="tel"
                          className="form-control"
                          id="whatsapp"
                          ref={whatsappRef} // Attach ref here
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="address" className="form-label">Address*</label>
                      <input type="text" className="form-control" required />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="message" className="form-label">Message</label>
                      <textarea className="form-control" id="message" required></textarea>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======================= Contact Us end ============================ */}
    </div>
  );
};

export default Contact;
